import { useMemo } from "react";
import useTransientStore from "../data/transcientStore";
import { getStatusColorMappings, StatusColorMapping } from "../utilities/StatusColors";

/**
 * Custom hook that provides status color mappings for legend displays
 * 
 * @param geometryType - Optional geometry type to adjust colors (e.g., "Polygon" for lighter colors)
 * @returns Array of status color mappings with id, name, description, and color
 */
export function useStatusColors(geometryType: string = "default"): StatusColorMapping[] {
  const selectedAddressSystemStatuses = useTransientStore(
    (state) => state.selectedAddressSystemStatuses
  );

  const statusColorMappings = useMemo(() => {
    if (!selectedAddressSystemStatuses || selectedAddressSystemStatuses.length === 0) {
      return [];
    }

    return getStatusColorMappings(selectedAddressSystemStatuses, geometryType);
  }, [selectedAddressSystemStatuses, geometryType]);

  return statusColorMappings;
}
